<template>
  <div class="detail-root wrap1">
    <h1 class="common-title" @click="$router.back()">
      <i class="el-icon-arrow-left back"></i>{{ $t($route.meta.title) }}
    </h1>
    <div class="wrap-content" style="padding: 12px 24px 0px">
      <div class="wrap1-tip">
        <i class="el-icon-info icon-info" style="color: #5D51DA"></i>
        <p>{{ $t('tip.del.content') }}</p>
      </div>
      <el-table row-key="id" v-load="loading" :height="tableHeight" :data="tableData" style="width: 100%">
        <!-- 固定薪资项名称/非固定薪资项名称 -->
        <el-table-column :label="isFixed ? $t('fix.label.name') : $t('unfix.label.name')" min-width="200px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.isSave" v-model="scope.row.name"></el-input>
            <span v-else>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <!-- 结算类型 -->
        <el-table-column prop="settlement_type" min-width="200px">
          <template slot="header">
            <div style="display: flex; align-items: center">
              <span>{{ $t('com.label.type') }}</span>
              <FilterIcon sort-prop="settlement_type" @on-filter="handleFilter" />
            </div>
          </template>
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.isSave && !scope.row.id"
              v-model="scope.row.settlement_type"
              @change="v => update_settlement_txt_by_code(v, scope.row)"
            >
              <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <span v-else>{{ scope.row.settlement_txt }}</span>
          </template>
        </el-table-column>
        <!-- 是否开启 -->
        <el-table-column min-width="200px">
          <template slot="header">
            <span>{{ $t('com.label.isopen') }}</span>
            <el-tooltip class="item" effect="dark" :content="$t('tip.content')" placement="top">
              <img class="icon_doubt" src="~@/assets/img/icon_doubt.png" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.switchValue"
              :disabled="
                is_salary_basic(scope) || is_salary_day(scope) || !scope.row.id || !$p('menu.payroll.management.edit')
              "
              @change="v => update_status(v, scope.row)"
            />
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('com.label.action')" min-width="200px">
          <template slot-scope="scope">
            <el-button
              v-if="+scope.row.is_user_setting !== 0 && $p('menu.payroll.management.edit')"
              type="text"
              @click="handleCreateOrUpdate(scope, scope.row.isSave)"
              >{{ scope.row.isSave ? $t('action.save') : $t('action.update') }}</el-button
            >
            <el-button
              v-if="scope.row.isSave && $p('menu.payroll.management.edit')"
              type="text"
              @click="handleCancelSave(scope, scope.$index)"
              >{{ $t('action.cancel') }}</el-button
            >
            <el-button
              v-if="scope.row.is_delete !== 0 && $p('menu.payroll.management.delete')"
              type="text"
              @click="delete_salary_item(scope, scope.$index)"
              >{{ $t('action.delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-button
        class="add-btn"
        icon="el-icon-plus"
        @click="handleAppendTableColumn"
        v-if="$p('menu.payroll.management.edit')"
        >{{ $t('action.add') }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FilterIcon from './components/FilterIcon.vue'

const TYPES = {
  fixed: 'fixed',
  unfixed: 'unfixed'
}

const CATE_IDS = {
  // 固定
  fixed: '4',
  // 非固定
  unfixed: '6'
}

export default {
  components: { FilterIcon },
  data() {
    return {
      loading: false,
      tableData: [],
      options: [],
      adding: false
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 120
    },
    isFixed() {
      const type = this.$route.path.split('/').pop()
      return type === TYPES.fixed
    },
    cate_id() {
      return this.isFixed ? CATE_IDS.fixed : CATE_IDS.unfixed
    }
  },
  created() {
    this.fetchTableData()
    this.get_settlement_type_enum()
  },
  methods: {
    // 判断是否是基本工资
    is_salary_basic(scope) {
      return scope.row.key === 'salary_basic'
    },
    // 判断是否是日薪
    is_salary_day(scope) {
      return scope.row.key === 'salary_day'
    },
    // 获取固定/非固定项列表
    fetchTableData(data = {}) {
      this.loading = true
      this.$http({
        url: '/web/payroll_setting/salaryItem',
        data: {
          cate_id: [this.cate_id],
          ...data
        }
      })
        .then(res => {
          // 扩展一些前端需要用的字段
          res.data.forEach(item => {
            // 用于保存/编辑状态切换
            item.isSave = false
            // 扩展一个默认是否开启的状态值
            item.defaultStatus = item.status
            // 根据后端的返回的状态字段转扩展一个boolean
            item.switchValue = item.status === '0'
            // 扩展一个默认薪资名称 用于取消还原
            item.defaultName = item.name
          })
          this.tableData = res.data
          this.adding = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取结算类型枚举列表
    get_settlement_type_enum() {
      this.$http({
        url: '/web/payroll_setting/itemInit',
        method: 'GET'
      }).then(res => {
        this.options = res.data.settlement_type
      })
    },
    // 联动更新结算类型文本值
    update_settlement_txt_by_code(code, row) {
      const option = this.options.find(item => item.code === code)
      row.settlement_txt = option.name
    },
    // 是否启用状态发生变化时的回调函数
    update_status(v, r) {
      r.status = v ? '0' : '1'
      if (r.id) {
        this.$http({
          url: '/web/payroll_sub_project/switchItem',
          data: {
            id: r.id,
            status: r.status
          }
        })
      }
    },
    delete_salary_item(scope, index) {
      // 如果id不存在 无需调接口 直接删
      if (!scope.row.id) {
        this.adding = false
        this.tableData.splice(index, 1)
        return
      }
      // 调接口删除
      this.loading = true
      this.$http({
        url: '/web/payroll_sub_project/deleteItem',
        data: { id: scope.row.id }
      })
        .then(() => {
          this.tableData.splice(index, 1)
        })
        .finally(() => {
          this.loading = false
        })
    },
    create_or_update_salary_item(url, data) {
      this.loading = true
      return this.$http({
        url,
        data
      }).finally(() => {
        this.loading = false
      })
    },
    // 创建/更新 固定/非固定项
    handleCreateOrUpdate(scope, isSave) {
      if (isSave) {
        // 保存校验
        if (!scope.row.name || !scope.row.settlement_type) {
          this.$message.warning(this.$t('required.msg'))
          return
        }
        const id = scope.row.id
        // url区分
        const url = id ? '/web/payroll_sub_project/updateitem' : '/web/payroll_sub_project/createitem'
        const data = {
          name: scope.row.name,
          settlement_type: scope.row.settlement_type
        }

        // 参数区分
        if (id) {
          data.id = id
        } else {
          data.cate_id = this.cate_id
        }

        // 创建/更新
        this.create_or_update_salary_item(url, data).then(() => {
          const isCreate = !scope.row.id
          if (isCreate) {
            this.adding = false
          } else {
            // 同步最新的默认薪资名称
            scope.row.defaultName = data.name
          }
          this.$set(scope.row, 'isSave', false)
          // 更新不需要刷新接口
          if (!id) {
            this.fetchTableData()
          }
        })
        return
      }
      this.$set(scope.row, 'isSave', !isSave)
    },
    // 结算类型排序
    handleFilter({ prop, order }) {
      if (order === 'default') {
        this.fetchTableData()
        return
      }
      this.fetchTableData({
        [prop]: order === 'ascending' ? '1' : '2'
      })
    },
    // 结算类型排序(废弃方法)
    handleSortChange({ column, prop, order }) {
      if (!order) {
        this.fetchTableData()
        return
      }
      this.fetchTableData({
        [prop]: order === 'ascending' ? '1' : '2'
      })
    },
    // 新增固定/非固定项
    handleAppendTableColumn() {
      if (this.adding) {
        this.$message.warning(this.$t('war.msg'))
        return
      }
      this.adding = true
      this.tableData.push({
        // 薪资项名称
        name: '',
        // 1 月结 2 日结
        settlement_type: 1,
        // 0 启用 1 禁用
        status: 0,
        // 默认为保存状态
        isSave: true,
        switchValue: true
      })
    },
    // 取消保存
    handleCancelSave(scope, index) {
      // 如果是新增的取消 直接删除
      if (!scope.row.id) {
        this.adding = false
        this.tableData.splice(index, 1)
        return
      }
      this.adding = false
      scope.row.isSave = false
      // 还原薪资名称
      scope.row.name = scope.row.defaultName
    }
  }
}
</script>

<style lang="less" scoped>
.common-title {
  cursor: pointer;
}

.detail-root .el-input {
  max-width: initial;
}

.icon_doubt {
  margin-top: 4px;
  margin-left: 4px;
  width: 16px;
  height: 16px;
  vertical-align: top;
}

.add-btn {
  margin-top: 24px;
  width: 100%;
  height: 32px;
  display: block;
  border-style: dashed;
}

.back {
  margin-right: 5px;
}

.filter {
  width: 16px;
  height: 16px;
  margin-left: 7px;
  cursor: pointer;
}
</style>
